module.exports = {"title":"Description","close":"Close"}


//////////////////
// WEBPACK FOOTER
// ./src/components/Stream/StreamDescriptionModal/locales/fr.json
// module id = 1815
// module chunks = 0